































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class CoreFooter extends Vue {
  links = [
    { name: 'Home', Link: '/dashboard' },
    { name: 'Creative Tim', Link: 'https://www.creative-tim.com' },
    { name: 'About Us', Link: 'https://creative-tim.com/presentation' },
    { name: 'Blog', Link: 'https://blog.creative-tim.com' }
  ]
}
